import "./saleshistory.scss";
import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { Select } from "@onshopfront/components";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog } from "../../../Actions/Dialogs/DialogActions";
import { assignCustomerToSale } from "../../../Actions/SellScreen/SellScreenCustomerActions";
import Button from "../../../Common/Buttons/Button";
import { type InjectedDataSourceProps, withDataSource } from "../../../Data/DataStores/WithDataSource";

const connector = connect();

interface Props extends ConnectedProps<typeof connector>, InjectedDataSourceProps {
    sale: string;
    onSubmit: (customer: string) => void;
    dispatch: ThunkDispatch<any, any, any>;
}

interface State {
    customer: null | {
        value: string;
        label: string;
    };
}

class AssignCustomer extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            customer: null,
        };

        this.handleAssignClick = this.handleAssignClick.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.searchCustomers = this.searchCustomers.bind(this);
    }

    protected searchCustomers(input: string): Promise<Array<{
        label: string;
        value: string;
    }>> {
        return this.props.data
            .then(source => {
                return source.customers.search(
                    input,
                    {
                        name      : true,
                        code      : true,
                        email     : true,
                        phone     : true,
                        exactMatch: false,
                        sort      : true,
                    }
                );
            })
            .then(customers => {
                const results = [];

                for(let i = 0, l = customers.length; i < l; i++) {
                    const customer = customers[i];

                    results.push({
                        label: [ customer.first_name, customer.last_name ].join(" "),
                        value: customer.uuid,
                    });
                }

                return results;
            });
    }

    protected handleSelect(option: null | { label: string; value: string; }): void {
        this.setState({
            customer: option,
        });
    }

    protected handleAssignClick(e: React.MouseEvent): void {
        if(this.state.customer) {
            this.props.dispatch(hideDialog());
            this.props.dispatch(assignCustomerToSale(this.props.sale, this.state.customer.value));

            this.props.onSubmit(this.state.customer.value);
        } else {
            e.stopPropagation();
        }
    }

    protected handleCancelClick(): void {
        this.props.dispatch(hideDialog());
    }

    public render(): React.ReactNode {
        return (
            <div className="assign-customer">
                <p>
                    Which customer would you like to assign to the sale (note, if loyalty is enabled, they will receive
                    the loyalty points for the sale)
                </p>
                <Select
                    value={this.state.customer}
                    onChange={this.handleSelect}
                    options={this.searchCustomers}
                    isClearable
                    placeholder={"Search customers..."}
                />
                <div className="buttons">
                    <Button type="button" classes={[ "button-cancel" ]} onClick={this.handleCancelClick}>
                        Cancel
                    </Button>
                    <Button type="button" classes={[ "button-save" ]} onClick={this.handleAssignClick}>
                        Assign
                    </Button>
                </div>
            </div>
        );
    }
}

export default connector(withDataSource(AssignCustomer));
